import { useState } from 'react';
import { httpsCallable } from 'firebase/functions';
import { functions } from '../lib/firebase';

const useCheckout = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const startCheckout = async (planId) => {
    setLoading(true);
    setError(null);
    try {
      const createCheckoutSession = httpsCallable(functions, 'createCheckoutSession');
      const { data } = await createCheckoutSession({ plan: planId, origin: window.location.origin });
      window.location.href = data.url;
    } catch (err) {
      setError('Could not start checkout. Please try again.');
      setLoading(false);
    }
  };

  return { startCheckout, loading, error };
};

export default useCheckout;
